export default "__VITE_PUBLIC_ASSET__902f650e__"